import { useMediaQuery } from './use-media-query.js';

export function useIsMobile() {
  return useMediaQuery('(max-width: 639px)');
}
